import { render } from "./NhomDichVuNoiBo.vue?vue&type=template&id=0bbf6a53&scoped=true&ts=true"
import script from "./NhomDichVuNoiBo.vue?vue&type=script&lang=ts"
export * from "./NhomDichVuNoiBo.vue?vue&type=script&lang=ts"

import "./NhomDichVuNoiBo.vue?vue&type=style&index=0&id=0bbf6a53&scoped=true&lang=css"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/PHCN/ChiaGioThucHien/VLTL_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbf6a53"]])

export default __exports__